export enum BlogRole {
  Owner = 'owner',
  Editor = 'editor',
  Viewer = 'viewer',
}

export const BLOG_ROLES: readonly BlogRole[] = [BlogRole.Owner, BlogRole.Editor, BlogRole.Viewer];

export function isBlogRole(value: unknown): value is BlogRole {
  return BLOG_ROLES.includes(value as BlogRole);
}

export interface BlogDto {
  id: string;
  name: string;
  description: string;
  timezone: string;
  createdAt: string;
}

export interface MyBlogDto extends BlogDto {
  role: BlogRole;
}

// WS-UC-1
export interface CreateBlogRequestDto {
  name: string;
  description?: string;
  timezone?: string;
}

// WS-UC-3
export interface UpdateBlogRequestDto {
  name?: string;
  description?: string;
  timezone?: string;
}

export interface MemberDto {
  userId: string;
  login: string;
  displayName: string;
  role: BlogRole;
  joinedAt: string;
}

// WS-UC-4
export interface AddMemberRequestDto {
  login: string;
  role: BlogRole;
}

// WS-UC-5
export interface UpdateMemberRequestDto {
  role: BlogRole;
}

export const BLOG_NAME_MAX_LENGTH = 100;
export const BLOG_DESCRIPTION_MAX_LENGTH = 1000;
